import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import BarcodeScannerComponent from "react-qr-barcode-scanner";
import { MdArrowBack, MdQrCodeScanner } from "react-icons/md";

const QRScanner = () => {
  const [error, setError] = useState(null);
  const [data, setData] = useState("Not Found");
  const [isScanning, setIsScanning] = useState(true);

  const navigate = useNavigate();

  const handleQRReadSuccessfully = (key) => {
    setIsScanning(false);
    setData(key);
    setTimeout(() => {
      navigate("/result", { state: { key } });
    }, 1500);
  };

  const handleGoBack = () => {
    navigate("/");
  };

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "#f8f9fa",
        padding: "20px",
        position: "relative",
      }}
    >
      <div
        onClick={handleGoBack}
        style={{
          position: "absolute",
          top: "20px",
          left: "20px",
          display: "flex",
          alignItems: "center",
          gap: "10px",
          padding: "10px 20px",
          backgroundColor: "#143785",
          color: "white",
          borderRadius: "25px",
          cursor: "pointer",
          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          boxShadow: "0 4px 12px rgba(20, 55, 133, 0.2)",
          zIndex: 1000,
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.backgroundColor = "#1a4ba3";
          e.currentTarget.style.transform = "translateY(-2px)";
          e.currentTarget.style.boxShadow = "0 6px 16px rgba(20, 55, 133, 0.3)";
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.backgroundColor = "#143785";
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 4px 12px rgba(20, 55, 133, 0.2)";
        }}
      >
        <MdArrowBack size={22} />
        <span style={{ fontWeight: "500" }}>Back</span>
      </div>

      <div
        style={{
          marginTop: "60px",
          textAlign: "center",
          marginBottom: "30px",
          animation: "slideDown 0.5s ease-out",
        }}
      >
        <h2 
          style={{ 
            color: "#143785", 
            marginBottom: "12px",
            fontSize: "2rem",
            fontWeight: "600",
            letterSpacing: "0.5px"
          }}
        >
          Scan QR Code
        </h2>
        <p 
          style={{ 
            color: "#666", 
            fontSize: "16px",
            maxWidth: "300px",
            margin: "0 auto",
            lineHeight: "1.5"
          }}
        >
          Position the QR code within the frame and hold steady
        </p>
      </div>

      <div
        style={{
          flex: 1,
          width: "100%",
          padding: "20px",
          backgroundColor: "white",
          borderRadius: "25px",
          boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
          position: "relative",
          animation: "fadeIn 0.8s ease-out",
          overflow: "hidden",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            position: "relative",
            width: "100%",
            height: "100%",
            maxWidth: "min(100vw - 40px, 100vh - 200px)",
            maxHeight: "min(100vw - 40px, 100vh - 200px)",
            backgroundColor: "#000",
            borderRadius: "15px",
            overflow: "hidden",
            margin: "auto",
          }}
        >
          {isScanning ? (
            <BarcodeScannerComponent
              // width={800}
              // height={800}
              
              onUpdate={(err, result) => {
                if (result) {
                  setData(result.text);
                  handleQRReadSuccessfully(result.text);
                } else {
                  setError("Unable to read QR code. Please try again.");
                }
              }}
            />
          ) : (
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#f8f9fa",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <MdQrCodeScanner size={40} color="#143785" />
                <span style={{ color: "#143785", fontSize: "16px" }}>
                  Processing...
                </span>
              </div>
            </div>
          )}
          
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "85%",
              height: "85%",
              border: "3px dashed #143785",
              borderRadius: "15px",
              pointerEvents: "none",
              animation: "pulse 2s infinite",
              zIndex: 1,
            }}
          />
        </div>
      </div>

      <div
        style={{
          marginTop: "30px",
          textAlign: "center",
          maxWidth: "80%",
          animation: "fadeIn 0.5s ease-out",
        }}
      >
        {error && (
          <div
            style={{
              backgroundColor: "#fff5f5",
              color: "#dc3545",
              padding: "12px 20px",
              borderRadius: "10px",
              marginBottom: "15px",
              display: "inline-block",
              boxShadow: "0 4px 12px rgba(220, 53, 69, 0.1)",
            }}
          >
            {error}
          </div>
        )}
        {data !== "Not Found" && (
          <div
            style={{
              backgroundColor: "#f0fff4",
              color: "#28a745",
              padding: "12px 20px",
              borderRadius: "10px",
              marginBottom: "15px",
              display: "inline-block",
              boxShadow: "0 4px 12px rgba(40, 167, 69, 0.1)",
              animation: "slideUp 0.5s ease-out",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <MdQrCodeScanner size={20} />
              <span>Successfully scanned!</span>
            </div>
          </div>
        )}
      </div>

      <style>
        {`
          @keyframes fadeIn {
            from {
              opacity: 0;
              transform: translateY(10px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          @keyframes slideDown {
            from {
              opacity: 0;
              transform: translateY(-20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          @keyframes slideUp {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          @keyframes pulse {
            0% {
              border-color: rgba(20, 55, 133, 0.5);
            }
            50% {
              border-color: rgba(20, 55, 133, 0.8);
            }
            100% {
              border-color: rgba(20, 55, 133, 0.5);
            }
          }
        `}
      </style>
    </div>
  );
};

export default QRScanner;
